"use strict";
document.addEventListener('click', (event) => {
    const target = event.target;
    const closeBtn = target.closest('.cookie-banner .js-close');
    if (closeBtn) {
        const banner = closeBtn.closest('.cookie-banner');
        banner === null || banner === void 0 ? void 0 : banner.classList.add('hidden');
    }
});
